import React from 'react';
// Real brand strips Brenda collaborated with (each image is a row of brand circles)
const ROW_TOP = ['https://cdn.magicpatterns.com/uploads/2AfVhWA2jeDScqHRPnee21/image.png', 'https://cdn.magicpatterns.com/uploads/48mGmeGkAufzh45yuwtVX7/image.png'];
const ROW_BOTTOM = ['https://cdn.magicpatterns.com/uploads/s2L7hdZ52NDqcp7nUPzxXQ/image.png', 'https://cdn.magicpatterns.com/uploads/2AfVhWA2jeDScqHRPnee21/image.png'];
interface MarqueeRowProps {
  images: string[];
  direction: 'ltr' | 'rtl';
}
function MarqueeRow({
  images,
  direction
}: MarqueeRowProps) {
  // Duplicate the set so the -50% translate loops seamlessly
  const items = [...images, ...images];
  return <div className="relative w-full overflow-hidden" data-id="element-50">
      <div className={`flex w-max items-center gap-8 md:gap-14 ${direction === 'ltr' ? 'animate-marquee-ltr' : 'animate-marquee-rtl'}`} data-id="element-51">
        {items.map((src, i) => <img key={i} src={src} alt="Marca que colaboró con Brenda" aria-hidden={i >= images.length} className="h-16 md:h-24 w-auto object-contain shrink-0 select-none pointer-events-none rounded-2xl bg-white px-3 py-2" draggable={false} data-id="element-52" />)}
      </div>
    </div>;
}
interface BrandsMarqueeProps {
  title?: string;
}
export function BrandsMarquee({
  title = 'MARCAS QUE CONFIARON EN MÍ'
}: BrandsMarqueeProps) {
  return <div className="w-full max-w-5xl mx-auto px-1" data-id="element-53">
      <div className="relative rounded-[2rem] p-[2px] bg-gradient-to-r from-[#D98BAF] via-brand-pinkDark to-[#D98BAF] shadow-[0_0_45px_rgba(217,139,175,0.45)]" data-id="element-54">
        <div className="bg-brand-navy rounded-[1.9rem] py-8 md:py-10 px-4 md:px-6 relative overflow-hidden" data-id="element-55">
          {/* Neon rose ambient glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-80 h-40 bg-[#D98BAF]/25 blur-[70px] rounded-full pointer-events-none" data-id="element-56" />

          <h3 className="relative text-center text-[#D98BAF] font-black text-sm md:text-xl tracking-[0.25em] uppercase mb-8 drop-shadow-[0_0_12px_rgba(217,139,175,0.55)]" data-id="element-57">
            {title}
          </h3>

          <div className="relative flex flex-col gap-5 md:gap-7" data-id="element-58">
            <MarqueeRow images={ROW_TOP} direction="ltr" data-id="element-59" />
            <MarqueeRow images={ROW_BOTTOM} direction="rtl" data-id="element-60" />

            {/* Edge fade masks */}
            <div className="absolute inset-y-0 left-0 w-12 md:w-24 bg-gradient-to-r from-brand-navy to-transparent pointer-events-none" data-id="element-61" />
            <div className="absolute inset-y-0 right-0 w-12 md:w-24 bg-gradient-to-l from-brand-navy to-transparent pointer-events-none" data-id="element-62" />
          </div>
        </div>
      </div>
    </div>;
}